<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.institutions', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form @submit="onSubmit" v-if="show">

                        <b-form-group
                                id="institution-group"
                                :label="$tc('message.institutions', 1)"
                                label-for="institution"
                        >
                            <select id="institution" v-model="$v.form.etablissement.$model"
                                    @change="clearErrorField('etablissement')"
                                    required
                                    multiple
                            >
                                <option data-placeholder="true"></option>
                                <option v-for="item in mInstitutions" :key="item.value" :value="item.value">
                                    {{ item.text }}
                                </option>
                            </select>
                            <b-form-invalid-feedback>
                                {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>
                            <span v-if="errorshasField('etablissement')" style="color:red">
                                    {{getErrorsField('etablissement')}}
                                    </span>
                        </b-form-group>
<!--                    <b-form-group-->
<!--                            id="institution-group"-->
<!--                            :label="$tc('message.institutions', 1)"-->
<!--                            label-for="institution"-->
<!--                    >-->
<!--                        <b-form-select-->
<!--                                id="institution"-->
<!--                                v-model="$v.form.etablissement.$model"-->
<!--                                :state="$v.form.etablissement.$dirty ? !(errorshasField('etablissement') || $v.form.etablissement.$error) : null"-->
<!--                                :options="mInstitutions"-->
<!--                                required-->
<!--                                @focus="clearErrorField('etablissement')"-->
<!--                        ></b-form-select>-->

<!--                        <b-form-invalid-feedback v-if="!$v.form.etablissement.required">-->
<!--                            {{ $t('message.requiredField') }}-->
<!--                        </b-form-invalid-feedback>-->

<!--                        <b-form-invalid-feedback v-else-if="errorshasField('etablissement')">-->
<!--                            {{ getErrorsField('etablissement') }}-->
<!--                        </b-form-invalid-feedback>-->
<!--                    </b-form-group>-->

                    <b-button type="submit" variant="primary">
                        {{ $t('message.save') }}
                    </b-button>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import SlimSelect from "slim-select";

    export default {
        name: "AddInstitution",

        computed: {
            ...mapGetters(["institutions","userInstitutions","hasGestionnaireRole","hasAdminRole", "errors"]),

            mInstitutions: function() {
                let iArray = [];

                let etablissements = (!this.hasGestionnaireRole && !this.hasAdminRole) ? this.userInstitutions : this.institutions;
                _.forEach(etablissements, function(institution) {
                    iArray.push({ value: institution.id, text: institution.name });
                });

                return iArray;
            },

            rows: function() {
                return this.mInstitutions.length;
            }
        },

        data() {
            return {
                patient_id: this.$route.params.patient,
                form: {
                    etablissement: [],
                },
                show: true
            }
        },

        methods: {
            getUserInstitutions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getUserInstitutions', { args : args });
            },

            getInstitutions() {
                this.$store.dispatch('getInstitutions', { args : {} });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        patient: this.patient_id,
                        etablissement: this.form.etablissement
                    };

                    let successMessage = this.$i18n.t('message.patientCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createPatientInstitution', { args, errorMessages, successMessage });
                }
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                etablissement: {
                    required
                }
            }
        },

        mounted() {
            // Fetch institution list
            this.getInstitutions();

// Fetch institution list
            this.getUserInstitutions();

            new SlimSelect({
                select: '#institution',
                placeholder: 'Select institution',
                limit:5
            });
        }
    }
</script>

<style scoped>

</style>